import React from 'react';
import * as Yup from 'yup';
import 'yup-phone';
import {Row, Col} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {Input, Form, MainLoader} from '@components';
import {GreenButton, StyledH3} from '@styled';
import {useDispatch, useSelector} from 'react-redux';
import {get} from 'lodash';
import {setRedirect} from './redux';
import {sagaActions} from './redux/saga';

const CorporateRegister = ({handleNext, token}) => {
  const [t] = useTranslation();

  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.register.createCorpLoading);
  const redirectNext = useSelector((state) => state.register.redirect);
  const userDetails = useSelector((state) => state.register.userDetails);

  React.useEffect(() => {
    if (redirectNext && redirectNext === 'CorporateRegister') {
      dispatch(setRedirect(''));
      handleNext(2);
    }
  }, [redirectNext]);

  const handleSubmit = (values) => {
    dispatch({
      type: sagaActions.CREATE_CORPORATE,
      payload: {
        values: {...values},
        token,
        redirect: true,
      },
    });
  };

  return (
    <>
      {isLoading && (
        <MainLoader
          minHeight="100vh"
          spinnerColor="#479541"
          background="rgba(0,0,0,0)"
        />
      )}
      <div>
        <Form
          initialValues={{
            corporateName: get(userDetails, 'Corporate', ''),
            entityCRNumber: '',
            tradingName: '',
            streetAddress: '',
            postalAddress: '',
          }}
          validationSchema={Yup.object({
            corporateName: Yup.string().required(
              t('register.corporate.required.corporateName')
            ),
            entityCRNumber: Yup.string()
              .required(t('register.corporate.required.entityCRNumber'))
              .test({
                name: 'is-valid-cr-number',
                message: t('register.corporate.required.invalidCRNumber'),
                test: (value) => {
                  return value && /^[a-z0-9]+$/i.test(value) ? true : false;
                },
              }),
            streetAddress: Yup.string().required(
              t('register.corporate.required.address1')
            ),
            postalAddress: Yup.string().required(
              t('register.corporate.required.address1')
            ),
          })}
          onSubmit={(values) => {
            handleSubmit(values);
          }}
        >
          <section className="content">
            <div className="container-fluid">
              <div className="card">
                <div className="card-body">
                  <StyledH3 className="mb-1 mt-0">
                    {t('register.corporate.corporateDetails')}
                  </StyledH3>
                  <Row className="mb-2">
                    <Col xs={12} lg={6}>
                      <Input
                        type="text"
                        name="corporateName"
                        id="corporateName"
                        label={t('register.corporate.name')}
                        placeholder=""
                        required
                      />
                    </Col>
                    <Col xs={12} lg={6}>
                      {' '}
                    </Col>
                  </Row>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <StyledH3 className="mb-1 mt-0">
                    {t('register.corporate.identifyingDetails')}
                  </StyledH3>
                  <Row className="mb-2">
                    <Col xs={12} lg={6}>
                      <Input
                        type="text"
                        name="entityCRNumber"
                        id="entityCRNumber"
                        label={t('register.corporate.entityCRNumber')}
                        placeholder=""
                        required
                      />
                    </Col>
                    <Col xs={12} lg={6}>
                      <Input
                        type="text"
                        name="tradingName"
                        id="tradingName"
                        label={t('register.corporate.tradingName')}
                        placeholder=""
                      />
                    </Col>
                  </Row>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <StyledH3 className="mb-1 mt-0">
                    {t('register.corporate.corporateAddressDetails')}
                  </StyledH3>
                  <Row className="mb-2">
                    <Col xs={12} lg={6}>
                      <Input
                        type="text"
                        name="streetAddress"
                        id="Address1"
                        label={t('register.corporate.address1')}
                        placeholder=""
                        required
                      />
                    </Col>
                    <Col xs={12} lg={6}>
                      <Input
                        required
                        type="text"
                        name="postalAddress"
                        id="Address2"
                        label={t('register.corporate.address2')}
                        placeholder=""
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
            <div className="mx-2">
              <Row className="mt-4">
                <Col>
                  <GreenButton type="submit" className="px-5">
                    {t('register.corporate.submitBtnLabel')}
                  </GreenButton>
                </Col>
              </Row>
            </div>
          </section>
        </Form>
      </div>
    </>
  );
};

export default CorporateRegister;
